// src/components/auth/MicrosoftCallback.jsx
import React, { useEffect, useState } from 'react';
import { tomarVolverA } from '../../utils/volverA';

const MicrosoftCallback = () => {
  const [status, setStatus] = useState('Verificando cuenta Microsoft...');

  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');

    if (!code) {
      setStatus('No se recibió código de autenticación...');
      setTimeout(() => {
        window.location.href = '/login?loginError=No se recibió código de autenticación';
      }, 1500);
      return;
    }

    fetch(`/api/auth/microsoft/token/${code}`)
      .then(r => r.json())
      .then(data => {
        if (data.token) {
          localStorage.setItem('dths_token', data.token);
          setStatus('¡Sesión iniciada! Redirigiendo...');
          window.location.href = tomarVolverA() || '/dashboard';
        } else {
          setStatus('Token inválido, redirigiendo...');
          setTimeout(() => {
            window.location.href = '/login?loginError=Token inválido o expirado';
          }, 1500);
        }
      })
      .catch(() => {
        setStatus('Error al obtener sesión, redirigiendo...');
        setTimeout(() => {
          window.location.href = '/login?loginError=Error al obtener sesión';
        }, 1500);
      });
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f8fafc',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '4px solid #e5e7eb',
        borderTop: '4px solid #2563eb',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite'
      }} />
      <p style={{ color: '#6b7280', fontWeight: '500', fontSize: '1rem' }}>
        {status}
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

export default MicrosoftCallback;